module.exports = __webpack_public_path__ + "static/media/slidingSub2.99b28412.png";